import { useRef } from "react";
import { useMotionValue, useSpring } from "framer-motion";

// 3D tilt + mouse-tracking shine (sets --mx/--my CSS vars) for hoverable cards.
export function useTilt(max = 7) {
  const ref = useRef(null);
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const rotateX = useSpring(rx, { stiffness: 260, damping: 24 });
  const rotateY = useSpring(ry, { stiffness: 260, damping: 24 });

  const onMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    ry.set((px - 0.5) * max * 2);
    rx.set((0.5 - py) * max * 2);
    el.style.setProperty("--mx", `${px * 100}%`);
    el.style.setProperty("--my", `${py * 100}%`);
  };

  const onMouseLeave = () => {
    rx.set(0);
    ry.set(0);
  };

  return { ref, style: { rotateX, rotateY, transformPerspective: 1100 }, onMouseMove, onMouseLeave };
}
